import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';

import './SellerInfo.styles.scss';

type SellerInfoProps = {
  className?: string;
  title: string;
  imageUrl: string;
};

const SellerInfo: React.FC<SellerInfoProps> = (props) => {
  const { className, title, imageUrl } = props;

  const classes = classNames('seller-info-contact', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p>{t('nowChattingWith')}</p>

      <div className="seller-info-contact__company">
        {!!imageUrl && <ResolveImage src={imageUrl} asCompanyLogo />}

        <div className="seller-info-contact__title">
          <p>{title || t('companyNameMissing')}</p>
          <span>{t('broker')}</span>
        </div>
      </div>

      <p className="seller-info-contact__note">
        {t('noteMessagingWithSeveralPeople')}
      </p>
    </div>
  );
};

export default SellerInfo;
